import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import { Button, Typography, TextField, Box, Modal } from '@mui/material';
import { Edit, Business, AccountTree, Numbers, AddLocationAlt, PinDrop,Delete } from '@mui/icons-material';
import { useNotification } from '../../contexts/NotificationContext';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { get_address, get_specific_address, edit_address, delete_address } from '../../services/profileService'

const columns = [


  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'code', label: 'ISO\u00a0Code', minWidth: 100 },
  {
    id: 'population',
    label: 'Population',
    minWidth: 170,
    align: 'right',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'size',
    label: 'Size\u00a0(km\u00b2)',
    minWidth: 170,
    align: 'right',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'density',
    label: 'Density',
    minWidth: 170,
    align: 'right',
    format: (value) => value.toFixed(2),
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

const rows = [
  createData('India', 'IN', 1324171354, 3287263),
  createData('China', 'CN', 1403500365, 9596961),
  createData('Italy', 'IT', 60483973, 301340),
  createData('United States', 'US', 327167434, 9833520),
  createData('Canada', 'CA', 37602103, 9984670),
  createData('Australia', 'AU', 25475400, 7692024),
  createData('Germany', 'DE', 83019200, 357578),
  createData('Ireland', 'IE', 4857000, 70273),
  createData('Mexico', 'MX', 126577691, 1972550),
  createData('Japan', 'JP', 126317000, 377973),
  createData('France', 'FR', 67022000, 640679),
  createData('United Kingdom', 'GB', 67545757, 242495),
  createData('Russia', 'RU', 146793744, 17098246),
  createData('Nigeria', 'NG', 200962417, 923768),
  createData('Brazil', 'BR', 210147125, 8515767),
];


const ProfileAddressTable = () => {

  const {showSuccess,showError} = useNotification();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tableData, setTableData] = useState([])
  const [editAddressId, setEditAddressId] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteAddress,setDeleteAddress] = useState(0)
  const [form, setForm] = useState({});


  useEffect(() => {
    async function fetchOrderData() {
      try {
        let data = JSON.parse(sessionStorage.getItem('user'))
        let send_data = parseInt(data['id'])
        console.log("Send Data => ", send_data)
        const response = await get_address(send_data)
        setTableData(response.data)
      }
      catch (error) {
        console.error("Error Occured on getting Order Data => ", error);

      }
    }
    fetchOrderData();
  }, [editModalOpen,deleteAddress])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEditAddress = async(address_id) => {
    console.log("Edit is Clicked => " , address_id)
    

    try {
      const response = await get_specific_address(address_id);
      setForm(response.data);

    }
    catch (error) {
      console.error("Error While Getting Data Please Try Again later")
    }

    setEditAddressId(address_id)
    setEditModalOpen(true)

  }

  const handleDeleteAddress = async (address_id) => {
    if(window.confirm("Want to Delete this Address ?")){
      console.log("Yes Deleted")
      try{
        const response = await delete_address(address_id);
        showSuccess("Address Deleted Successfully");
        setDeleteAddress(1);
      }
      catch(error){
        console.error("Error Happened => ", error);
      }
    }
    else{
      return ;
    }
  }

  return (
    <>

      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Address Name</TableCell>
                <TableCell>Street Address</TableCell>
                <TableCell>Pincode</TableCell>
                <TableCell sx={{textAlign:'center'}}>Actions</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((items, index) => {
                return (
                  <TableRow>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{items.address_name}</TableCell>
                    <TableCell> {items.street_address}</TableCell>
                    <TableCell>{items.pincode}</TableCell>
                    <TableCell sx={{textAlign:'center'}}>
                    <Button onClick={() => handleEditAddress(items.id)}><Edit sx={{ color: "blue" }}/></Button>
                    <Button onClick={() => handleDeleteAddress(items.id)}><Delete sx={{ color: "red" }}/></Button>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <AddAddressModal editModalOpen={editModalOpen} setEditModalOpen={setEditModalOpen} editAddressId={editAddressId} form={form} setForm={setForm} />
    </>
  );
}



const AddAddressModal = ({ editModalOpen, setEditModalOpen, editAddressId,form,setForm }) => {


  const { showSuccess, showError } = useNotification();

  const [modalForm, setModalForm] = useState([
    { "id": 1, "name": "address_name", "label": "Address Name", icon: <Business sx={{ color: 'text.secondary', mr: 1 }} /> },
    { "id": 2, "name": "building_name", "label": "Building Name", icon: <AccountTree sx={{ color: 'text.secondary', mr: 1 }} /> },
    { "id": 3, "name": "building_number", "label": "Building Number", icon: <Numbers sx={{ color: 'text.secondary', mr: 1 }} /> },
    { "id": 4, "name": "street_address", "label": "Street Address", icon: <AddLocationAlt sx={{ color: 'text.secondary', mr: 1 }} /> },
    { "id": 5, "name": "pincode", "label": "Pincode", icon: <PinDrop sx={{ color: 'text.secondary', mr: 1 }} /> }
  ])


  // const [form, setForm] = useState({
  //   "address_name": "",
  //   "building_name": "",
  //   "building_number": "",
  //   "street_address": "",
  //   "pincode": ""

  // })
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };



  // console.log("Calllleled")
  // async function fetchAddressData(){

  // }
  // fetchAddressData()


  const handleAddressChange = (e) => {
    const updateData = {
      ...form,
      [e.target.name]: e.target.value
    }
    setForm(updateData)
  }



  console.log(form)

  const submitAddress = async () => {
    try {
      const response = await edit_address(form);
      showSuccess("Address Updated Successfully")
      setEditModalOpen(false)
    }
    catch (error) {
      console.error("Error on Updating Address")
      showError("Something Went Wrong");

    }
  }
  console.log("Form => ", form)
  return (
    <Modal
      open={editModalOpen}
      onClose={() => setEditModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography variant='h5' sx={{ mb: 2, textAlign: 'center' }}>Update Address</Typography>
        {modalForm.map((items, index) => {
          return (
            <TextField fullWidth
              name={items.name}
              label={items.label}
              value={form[items.name]}
              onChange={(e) => handleAddressChange(e)}

              size="medium"
              InputProps={{
                startAdornment: items.icon
              }}
              sx={{
                mb: 4,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }

              }}
            >
            </TextField>
          )
        }


        )}
        <Box sx={{ textAlign: 'center' }}>
          <Button variant="contained" onClick={submitAddress}>Update Address</Button>
        </Box>

      </Box>
    </Modal>
  )
}


export default ProfileAddressTable;